module.exports = __webpack_public_path__ + "img/tourtravel1.5efa95d2.png";